import {
  Box,
  FormControl,
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import compInfos from "./pagination.json";
import { useLangContext } from "../../../../context/langContext";
import { useWindowWidth } from "../../../../hooks/windowHook";
import ReloadButton from "../../reload-button/ReloadButton";
import RemoveAllButton from "../../remove-all-button/RemoveAllButton";
import { Fragment } from "react/jsx-runtime";

interface ICustomPaginationProps {
  multiple?: boolean;
  dataLength?: number;
  page?: number;
  handlePage: (page: number) => void;
  handlePageSizeChange: (event: any) => void;
  totalPages?: number;
  pageSize?: number;
  reloadAction?: () => void;
  removeAllAction?: () => void;
  onlyShowCount?: boolean;
}

const CustomPagination = ({
  multiple,
  dataLength,
  page,
  handlePage,
  handlePageSizeChange,
  totalPages,
  pageSize,
  reloadAction,
  removeAllAction,
  onlyShowCount,
}: Readonly<ICustomPaginationProps>) => {
  const { lang } = useLangContext();
  const isMobile = useWindowWidth(700);

  const infos = compInfos[lang];

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="4px"
      py={"20px"}
      // px={{ md: "20px", xs: "0" }}
      sx={{
        minWidth: "fit-content",
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap="4px"
      >
        {removeAllAction && (
          <RemoveAllButton removeAllAction={removeAllAction} />
        )}
        {reloadAction && <ReloadButton reloadAction={reloadAction} />}
      </Stack>
      <Stack
        direction="row"
        gap={{ md: "5px", xs: "2px" }}
        sx={{
          display: { md: "flex" },
          width: { md: "fit-content" },
          border: ".8px solid #00000023",
          borderRadius: "5px",
          paddingY: { xs: "6px", md: "10px" },
          paddingX: { xs: "6px", md: "10px" },
          minWidth: { xs: "0", md: "fit-content" },
        }}
      >
        <Typography
          variant="warningRegular"
          whiteSpace="nowrap"
          color={({ palette }) => palette.dark[20]}
        >
          {infos.count}
        </Typography>
        <Typography
          variant="warningRegular"
          color={({ palette }) => palette.dark[20]}
        >
          {dataLength}
        </Typography>
      </Stack>
      {!onlyShowCount && (
        <Fragment>
          <FormControl
            sx={{
              width: "fit-content",
              border: ".8px solid #00000023",
              borderRadius: "5px",
              display: { sm: "flex", xs: "none" },
            }}
            component={Stack}
            direction="row"
            gap={{ md: "5px", xs: "2px" }}
          >
            <Stack
              direction="row"
              alignItems="center"
              px={{ md: "10px", xs: "2px" }}
            >
              <Typography
                variant="warningRegular"
                color={({ palette }) => palette.dark[20]}
                whiteSpace="nowrap"
              >
                {infos.displayNumber}
              </Typography>
              <Select
                sx={{
                  // paddingY: { xs: "6px", md: "10px" },
                  // paddingX: { xs: "6px", md: "10px" },
                  height: { xs: "30px", md: "40px" },
                  paddingY: "0",
                  // width: "55px",
                  border: "none",
                  outline: "none",
                  "&:active": {
                    border: "none",
                    outline: "none",
                  },
                  "& fieldset": {
                    border: "none",
                    outline: "none",
                  },
                }}
                value={pageSize}
                defaultValue={pageSize}
                onChange={handlePageSizeChange}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </Stack>
          </FormControl>
          <Pagination
            dir="ltr"
            color="primary"
            count={totalPages}
            onChange={(event, value) => handlePage(value)}
            page={page}
            size="large"
            variant="outlined"
            shape="rounded"
            sx={{
              "& .MuiPaginationItem-root": {
                "&.Mui-selected": {
                  bgcolor: ({ palette }) => palette.gray[100],
                  color: ({ palette }) => palette.dominant.main,
                  border: "none",
                  "&:hover": {
                    bgcolor: ({ palette }) => palette.gray[100],
                    color: ({ palette }) => palette.dominant.main,
                    cursor: "default",
                  },
                },
              },
            }}
            siblingCount={1}
            boundaryCount={0}
            renderItem={(item) => {
              if (!multiple) {
                if (item.type === "page" && item.page === page) {
                  return (
                    <PaginationItem
                      {...item}
                      size={isMobile ? "medium" : "large"}
                    />
                  );
                }
                if (item.type === "previous" || item.type === "next") {
                  return (
                    <PaginationItem
                      {...item}
                      size={isMobile ? "medium" : "large"}
                    />
                  );
                }
                return null;
              } else {
                return (
                  <PaginationItem
                    {...item}
                    size={isMobile ? "medium" : "large"}
                  />
                );
              }
            }}
          ></Pagination>
        </Fragment>
      )}
    </Stack>
  );
};

export default CustomPagination;
